module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Form_Element_Checkbox', {
		_setValue: function(value) {
			return this[value ? 'check' : 'unCheck']();
		},

		getValue: function() {
			return this.isChecked();
		},

		_updateValue: function() {
			this._setValue(this.value);
		},

		isChecked: function () {
			check = this.formElement.checked ? 1 : 0;
			return check;
		},

		check: function () {
			this.formElement.checked = true;
			return this;
			
		},

		unCheck: function () {
			this.formElement.checked = false;
			return this;
		},

		toggle: function () {
			return this.isChecked() ? this.unCheck() : this.check();
		}

	}, 'Form_Element');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/form/elements/checkbox.js
// module id = 189
// module chunks = 0